import React, {useState, useEffect, useRef} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './assets/css/DocumentDocTypeModal.css';
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
import {Carousel} from 'react-bootstrap';

const AnalysisUserModal = ({show, onHide, onSave, initialData}) => {


    const [fullImage, setFullImage] = useState(null);

    const [typeDoc, setTypeDoc] = useState({formFile: ''});
    const [loading, setLoading] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [showRejectModal, setShowRejectModal] = useState(false); // Controla a exibição do segundo modal
    const [rejectObservation, setRejectObservation] = useState(''); // Campo para observação
    const [selectedDocs, setSelectedDocs] = useState([]); // Armazena os documentos selecionados para rejeição
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setTypeDoc({formFile: ''});
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    }, [show]);

    const handleSelect = (selectedIndex, e) => {
        setSelectedIndex(selectedIndex);
    };

    const handleImageClick = (imgUrl) => {
        setFullImage(imgUrl);
    };


    const handleApprove = () => {
        handleStatusChange('accepted');
    };

    const handleRefused = () => {
        handleStatusChange('refused');
    };

    const handleReprovarDocumentos = () => {
        // Exibe o segundo modal para adicionar a observação e selecionar documentos
        setShowRejectModal(true);
    };


    const handleStatusRejectDocChange = (observation = '', rejectedDocs = [], id) => {
        setLoading(true);
        const id_doc_accept_user = initialData?.id;
        const data = {
            id_doc_accept_user, // ID do usuário interessado
            comment: observation, // Inclui a observação se houver
            doc_id: rejectedDocs.map(doc => doc.id), // Inclui os IDs dos documentos rejeitados
        };

        ApiService.send("post", process.env.REACT_APP_URL_API + 'documents/docrejected', data, true)
            .then((res) => {
                if (res.code === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'Solicitação reprovada com sucesso.',
                    });
                    onHide(true); // Função para fechar o modal ou limpar o estado
                }
            })
            .catch((error) => {
                console.error('Erro ao reprovar solicitação:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response?.data?.message || 'Ocorreu um erro ao reprovar a solicitação.',
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleStatusChange = (status, observation = '', rejectedDocs = []) => {
        setLoading(true);

        const data = {
            user_interested: initialData.user_info.id,
            situation: status,
            observation, // Inclui a observação
            rejected_docs: rejectedDocs, // Inclui os documentos rejeitados
        };

        // Define a rota com base no status
        const endpoint = status === 'accepted'
            ? `${process.env.REACT_APP_URL_API}documents/approve`
            : `${process.env.REACT_APP_URL_API}documents/reject`;

        ApiService.send("post", endpoint, data, true)
            .then((res) => {
                if (res.code === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: `Solicitação ${status === 'accepted' ? 'aprovada' : 'reprovada'} com sucesso.`,
                    });
                    onHide(true); // Oculta o modal ou realiza outra ação de fechamento
                }
            })
            .catch((error) => {
                console.error(`Erro ao ${status === 'accepted' ? 'aprovar' : 'reprovar'} solicitação:`, error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response?.data?.message || `Ocorreu um erro ao ${status === 'accepted' ? 'aprovar' : 'reprovar'} a solicitação.`,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const renderCarouselItems = () => {
        return initialData?.docs?.map((doc, index) => {
            if (!doc.path) {
                return (
                    <Carousel.Item key={index}>
                        <div className="alert alert-warning" role="alert">
                            Documento sem anexo para exibição.
                        </div>
                    </Carousel.Item>
                );
            }
            const cleanPath = doc.path.split('?')[0];
            const fileExtension = cleanPath.split('.').pop().toLowerCase();

            if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
                return (
                    <Carousel.Item key={index}>
                        <div
                            style={{ cursor: 'zoom-in', textAlign: 'center' }}
                            onClick={() => handleImageClick(doc.path)}
                        >
                            <img
                                src={doc.path}
                                alt={doc.doc_type.name}
                                style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}
                            />
                        </div>
                    </Carousel.Item>
                );
            }


            if (fileExtension === 'pdf') {
                return (
                    <Carousel.Item key={index}>
                        <embed
                            src={doc.path}
                            type="application/pdf"
                            width="100%"
                            height="600px"
                        />
                    </Carousel.Item>
                );
            }

            return (
                <Carousel.Item key={index}>
                    <a href={doc.path} target="_blank" className="btn btn-primary mb-2" download>
                        Download do Arquivo
                    </a>
                </Carousel.Item>
            );
        });
    };

    const renderDocumentInfo = () => {
        const docs = initialData?.docs;

        if (!Array.isArray(docs) || docs.length === 0 || selectedIndex == null || !docs[selectedIndex]) {
            return (
                <div className="document-info mb-3">
                    <h5>Informações do Documento</h5>
                    <p>Nenhum documento selecionado ou disponível.</p>
                </div>
            );
        }

        const doc = docs[selectedIndex];

        return (
            <div className="document-info mb-3">
                <h5>Informações do Documento</h5>

                <div className="row">
                    <div className="col-4">
                        <strong>{doc.doc_type?.name || 'Nome não disponível'}:</strong> {doc.doc_number || 'Número não disponível'}
                    </div>
                    <div className="col-4"><strong>Estado:</strong> {doc.state || 'Não disponível'}</div>
                    <div className="col-4">
                        <strong>Tipo de Pessoa:</strong> {doc.type_of_person === 1 ? 'Física' : doc.type_of_person === 2 ? 'Jurídica' : 'Não informado'}
                    </div>
                </div>
            </div>
        );
    };


    return (
        <>
            {show && <div className="modal-backdrop fade show"></div>}
            <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1"
                 aria-labelledby="documentDocTypeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="documentDocTypeModalLabel">Análise de Credenciamento</h5>
                            <button type="button" className="btn-close" onClick={() => onHide(false)} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {initialData?.user_info && (

                                <div className="profile-info mb-4">
                                    <div className="row">
                                        <div
                                            className="col-12 col-sm-12 col-md-2 col-lg-2 align-center mb-3 m-4">
                                            <img
                                                src={initialData.user_info.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                alt={initialData.user_info.name}
                                                className="hospital-image"
                                                style={{
                                                    width: '100%',
                                                    maxWidth: '150px',
                                                    height: 'auto'
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-8 col-lg-7 mt-2">
                                            <h5>Informações do Perfil</h5>
                                          <div className="row">
                                              <div className="col-6">
                                                  <strong
                                                      className="text-info">Nome:</strong> {initialData.user_info.name}<br/>
                                                  <strong
                                                      className="text-info">CPF:</strong> {initialData.user_info.cpf}<br/>
                                                  <strong className="text-info">Situação:</strong>
                                                  {initialData.situation === "pending" && (
                                                      <span className="text-warning">
                                                                    <i className="fa fa-times text-warning"></i> Pendente
                                                                </span>
                                                  )}
                                                  {initialData.situation === "accepted" && (
                                                      <span className="text-success">
                                                                    <i className="fa fa-check text-success"></i> Aprovado
                                                                </span>
                                                  )}
                                                  {initialData.situation === "refused" && (
                                                      <span className="text-danger">
                                                                    <i className="fa fa-close text-danger"></i> Rejeitado
                                                                </span>
                                                  )}
                                                  {initialData.situation === "remake" && (
                                                      <span className="text-danger">
                                                                                <i className="fa fa-address-card text-danger"></i> Recusado Documentação
                                                                            </span>
                                                  )}


                                              </div>
                                              <div className="col-6">
                                                  <strong
                                                      className="text-info">Cidade:</strong> {initialData.user_info.city}<br/>
                                                  <strong
                                                      className="text-info">Estado:</strong> {initialData.user_info.state}<br/>
                                                  <strong
                                                      className="text-info">Email:</strong> {initialData.user_info.email}<br/>

                                              </div>

                                          </div>


                                            {initialData?.user_info?.phone && (
                                                <div className="d-flex align-items-center">
                                                    <a
                                                        target="_blank"
                                                        href={`https://wa.me/${initialData.user_info.ddd}${initialData.user_info.phone}/?text=${encodeURIComponent('')}`}
                                                        className="btn btn-sm d-flex justify-content-center align-items-center"
                                                        style={{
                                                            backgroundColor: '#25D366',
                                                            color: '#fff',
                                                            fontSize: '1.0rem',
                                                            width: '30px',
                                                            height: '30px',
                                                            borderRadius: '50%',
                                                        }}
                                                    >
                                                        <i className="fa fa-whatsapp"></i>
                                                    </a>
                                                    <span className="ms-2">
                                                      ({initialData.user_info.ddd}) {initialData.user_info.phone}
                                                    </span>
                                                </div>
                                            )}

                                        </div>


                                        <div
                                            className="col-12 col-lg-2 d-flex flex-column align-items-stretch">

                                            {(initialData.situation === "pending" || initialData.situation === "accepted") && (
                                                <button type="button" className="btn btn-danger btn-sm  mb-2"
                                                        onClick={() =>handleRefused()} disabled={loading}>
                                                    <i className="fa fa-close"></i> Rejeitar
                                                </button>
                                            )}

                                            {(initialData.situation === "pending" || initialData.situation === "refused") && (
                                                <button type="button" className="btn  btn-sm  btn-success "
                                                        onClick={() =>handleApprove()} disabled={loading}>
                                                    <i className="fa fa-check"></i> Aprovar
                                                </button>
                                            )}
                                            {(initialData.situation === "pending" || initialData.situation === "refused") && (
                                            <button type="button" className="btn btn-warning  btn-sm   mt-2"
                                                    onClick={() =>handleReprovarDocumentos()}
                                                    disabled={loading}>
                                                <i className="fa fa-exclamation-triangle"></i> Reprovar
                                                Documentos
                                            </button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            )}

                            <div className="row">
                                <div className="col-md-2">
                                    <ul className="list-group">
                                        {initialData?.docs && initialData.docs.map((doc, index) => (
                                            <li
                                                key={index}
                                                className={`list-group-item ${selectedIndex === index ? 'active' : ''}`}
                                                onClick={() => handleSelect(index)}
                                            >
                                                {doc.doc_type.name || `Documento ${index + 1}`}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col-md-10">
                                    {renderDocumentInfo()}
                                    <Carousel activeIndex={selectedIndex} onSelect={handleSelect} controls={false}
                                              indicators={false}>
                                        {renderCarouselItems()}
                                    </Carousel>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => onHide(false)}>Cancelar</button>
                            </div>
                        </div>
                        {loading && <LoadingScreen/>}
                    </div>
                </div>
            </div>

            {/* Segundo Modal: Reprovar Documentos */}
            <div className={`modal fade ${showRejectModal ? 'show d-block' : ''}`} tabIndex="-1"
                 aria-labelledby="rejectDocumentModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="rejectDocumentModalLabel">Reprovar Documentos</h5>
                            <button type="button" className="btn-close" onClick={() => setShowRejectModal(false)}
                                    aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Observação sobre a Reprovação</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={rejectObservation}
                                    onChange={(e) => setRejectObservation(e.target.value)}
                                />
                            </div>
                            <div className="form-group mt-4">
                                {initialData?.docs.length > 0 && (
                                    <>
                                        <label>Selecione os Documentos a Reprovar</label>
                                        <ul className="list-group">
                                            {initialData?.docs.map((doc, index) => (
                                                <li key={index} className="list-group-item">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedDocs.includes(doc)}
                                                        onChange={() => {
                                                            const updatedDocs = selectedDocs.includes(doc)
                                                                ? selectedDocs.filter((d) => d !== doc)
                                                                : [...selectedDocs, doc];
                                                            setSelectedDocs(updatedDocs);
                                                        }}
                                                    />
                                                    <span
                                                        className="ms-2">{doc.doc_type.name || `Documento ${index + 1}`}</span>
                                                </li>

                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary"
                                    onClick={() => setShowRejectModal(false)}>Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-warning"
                                onClick={() => {
                                    setShowRejectModal(false);
                                    handleStatusRejectDocChange(rejectObservation, selectedDocs, initialData?.id);
                                }}
                            >
                                Reprovar Documentos
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {fullImage && (
                <div
                    className="modal show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1055 }}
                    onClick={() => setFullImage(null)}
                >
                    <div className="modal-dialog modal-dialog-centered modal-fullscreen">
                        <div className="modal-content bg-transparent border-0 position-relative">
                            {/* Botão flutuante no canto superior direito */}
                            <button
                                type="button"
                                className="btn-close btn-close-white position-absolute"
                                style={{ top: '1rem', right: '4rem', zIndex: 9999 }}
                                onClick={(e) => {
                                    e.stopPropagation(); // evita fechar ao clicar no botão
                                    setFullImage(null);
                                }}
                                aria-label="Fechar"
                            ></button>

                            <div className="modal-body d-flex justify-content-center align-items-center">
                                <img
                                    src={fullImage}
                                    alt="Visualização em tela cheia"
                                    style={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </>
    )
        ;
};

export default AnalysisUserModal;
